module.exports = __webpack_public_path__ + "img/39b28ef.png";